import { render, staticRenderFns } from "./PresentLevelsLoadingGoalCards.vue?vue&type=template&id=47c1a5ed&scoped=true"
import script from "./PresentLevelsLoadingGoalCards.vue?vue&type=script&lang=js"
export * from "./PresentLevelsLoadingGoalCards.vue?vue&type=script&lang=js"
import style0 from "./PresentLevelsLoadingGoalCards.vue?vue&type=style&index=0&id=47c1a5ed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c1a5ed",
  null
  
)

export default component.exports